<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Borç/Alacak</label>
            <v-select-list :options="baTypes" label="name" placeholder="Borç/Alacak" v-model="baType"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Yaka</label>
            <v-select-list :options="collarStatuses" label="Name" placeholder="Yaka" v-model="collarStatus"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Banka Hesap Adı</label>
            <v-select-list :options="bankaPlans" label="Name" placeholder="Banka Hesap Adı" v-model="bankaPlan"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Muhasebe Hesap Kodu</label>
            <input class="form-control" v-model="value.NetsisAccountCode" placeholder="Muhasebe Hesap Kodu"/>
        </div>
        <div class="col-12">
            <label class="form-label">Tip</label>
            <v-select-list :options="types" label="Name" placeholder="Tip" v-model="type"></v-select-list>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'

export default {
    props:{
        value:Object
    },
    data(){
        return {
            baTypes:[
                {name:'Borç',value:'B'},
                {name:'Alacak',value:'A'},
            ],
            collarStatuses:[],
            bankaPlans:[],
            types:[],
        }
    },
    mounted(){
        this.getCollarStatuses()
        this.getMuhasabePlanList()
        this.getBankaOdemeTypes()
    },
    methods:{
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res => {
                this.collarStatuses = res.data.Data
            })
        },
        getMuhasabePlanList(){
            SystemDataApi.BankaPlani().then(res=>{
                this.bankaPlans = res.data.Data
            })
        },
        getBankaOdemeTypes(){
            SystemDataApi.BankaOdemeType().then(res=>{
                this.types = res.data.Data
            })
        },
    },
    computed:{
        baType:{
            get:function(){
                return this.baTypes.find(b=>b.value==this.value.BAType)
            },
            set:function(value){
                this.value.BAType = value?.value || null
            }
        },
        projectCode:{
            get:function(){
                return this.projectCodes.find(b=>b.value==this.value.G_R)
            },
            set:function(value){
                this.value.G_R = value?.value || null
            }
        },
        collarStatus:{
            get:function(){
                return this.collarStatuses.find(s=>s.Id == this.value.CollarStatusId)
            },
            set:function(value){
                this.value.CollarStatusId = value?.Id || null
            }
        },
        bankaPlan:{
            get:function(){
                return this.bankaPlans.find(s=>s.Value==this.value.NetsisBankaDekontHesapPlaniType)
            },
            set:function(value){
                this.value.NetsisBankaDekontHesapPlaniType = value?.Value != null ? value.Value : null
            }
        },
        type:{
            get:function(){
                return this.types.find(s=>s.Value==this.value.Type)
            },
            set:function(value){
                this.value.Type = value?.Value != null ? value.Value : null
            }
        }
    }
}
</script>